<template>
  <div
    class="circle-button"
    @mouseenter="restartAnimation"
  >
    <svg width="66" height="66" viewBox="0 0 66 66">
      <!-- 只有一个圆环，动画用 key 强制重播 -->
      <circle
        :key="animationKey"
        class="animated-ring"
        cx="33"
        cy="33"
        r="30"
        stroke="black"
        stroke-width="2"
        fill="none"
      />
    </svg>
    <div v-if="type=='pre'" class="icon pre-icon"></div>
    <div v-else class="icon next-icon"></div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  type: {
    type: String,
    default: 'next'
  }
})

const animationKey = ref(0)

function restartAnimation() {
  // 触发重建 <circle> 元素，从而动画重新播放
  animationKey.value += 1
}
</script>

<style scoped>
.circle-button {
  position: relative;
  &:hover {
    .pre-icon {
      animation: btn-pre-icon-rotate 0.4s linear;
    }
    .next-icon {
      animation: btn-next-icon-rotate 0.4s linear;
    }
  }
  .icon {
    width: 33px;
    height: 33px;
    background-image: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/7d4b70c240b44e8d9844754f33039606.png');
    background-size: 100% 100%;
    position: absolute;
    left: 16px;
    top: 16px;
  }
  .pre-icon {
    transform: rotate(-180deg);
  }

}
.animated-ring {
  stroke-dasharray: 188.5;
  stroke-dashoffset: 0; /* 默认完整圆环 */
  transform: rotate(-90deg);
  transform-origin: center;
  animation: draw-ring 0.3s linear;
  animation-fill-mode: forwards;
}

@keyframes btn-pre-icon-rotate {
  0% {
    transform: translateX(20px) rotate(-180deg);
  }
  50% {
    transform: translateX(-20px) rotate(-180deg); 
  }
  100% {
    transform: translateX(0px) rotate(-180deg); 
  }
}
@keyframes btn-next-icon-rotate {
  0% {
    transform: translateX(-20px);
  }
  50% {
    transform: translateX(20px); 
  }
  100% {
    transform: translateX(0px); 
  }
}

@keyframes draw-ring {
  from {
    stroke-dashoffset: 188.5;
  }
  to {
    stroke-dashoffset: 0;
  }
}
</style>